<div class="animated fadeIn rounded">
    <div class="card">
        <form class="form-horizontal" [formGroup]="tokenForm" (ngSubmit)="tokenForm.valid && createToken()">
            <div class="card-header">
                <i class="fa-solid fa-square-binary"></i> Token de Autorización
            </div>
            <div class="card-body">
                <accordion>
                    <accordion-group [isOpen]="true">
                        <span accordion-heading>
                            <i class='fa fa-question'></i> Información del Token
                        </span>
                        <div class="form-group row">
                            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Usuario solicitante</b>
                                <span appRequiredAsterisk [formGroup]="tokenForm" controlName="userRequester"></span>
                            </label>
                            <div class="col-5 col-md-5 col-sm-4 input-group">
                                <input type="text" class="form-control" formControlName="userRequesterDescription"
                                    [ngClass]="tokenForm.controls.userRequester.errors ? 'is-invalid' : 'is-valid'"
                                    readOnly>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button"
                                        (click)="showSellerList()"><i class="fa fa-search"></i></button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Correo</b>
                                <span appRequiredAsterisk [formGroup]="tokenForm" controlName="email"></span>
                            </label>
                            <div class="col-5 col-md-5 col-sm-4 ">
                                <input type="email" class="form-control" formControlName="email"
                                    [ngClass]="tokenForm.controls.email.errors ? 'is-invalid' : 'is-valid'">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Observaciones</b>
                                <span appRequiredAsterisk [formGroup]="tokenForm" controlName="observations"></span>
                            </label>
                            <div class="col-5 col-md-5 col-sm-4 ">
                                <textarea class="form-control" formControlName="observations" rows="10"
                                    [ngClass]="tokenForm.controls.observations.errors ? 'is-invalid' : 'is-valid'">
                        </textarea>

                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Proceso</b>
                                <span appRequiredAsterisk [formGroup]="tokenForm" controlName="process"></span>
                            </label>
                            <div class="col-5 col-md-5 col-sm-4 ">
                                <ng-select formControlName="process" [items]="processes" bindLabel="value"
                                    bindValue="key"></ng-select>
                            </div>
                        </div>

                    </accordion-group>
                </accordion>

            </div>
            <div class="card-footer">
                <div class=" btn-group">
                    <button type="submit" class="btn btn-outline-primary">Generar Token</button>
                </div>
            </div>
        </form>
    </div>
</div>